module.exports = __webpack_public_path__ + "static/8-874fe14974dfc4aef168702d675f9e3a.jpg";